import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLanding from "./components/MainLanding";
import RetirementPlanner from "./components/RetirementPlanner";
import EducationPlanner from "./components/EducationPlanner";
import SWPPlanner from "./components/SWPPlanner";
import SuccessStories from "./components/SuccessStories";
import ComingSoon from "./components/ComingSoon";
import ErrorBoundary from "./components/ErrorBoundary";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";

const RetirementPage = () => {
  return (
    <div className="min-h-screen">
      <RetirementPlanner />
      <SuccessStories />
    </div>
  );
};

function App() {
  React.useEffect(() => {
    const redirectPath = sessionStorage.getItem('redirectPath');
    if (redirectPath) {
      sessionStorage.removeItem('redirectPath');
      window.history.replaceState(null, '', redirectPath);
    }
  }, []);

  return (
    <ErrorBoundary>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MainLanding />} />
            <Route path="/retirement-planner" element={<RetirementPage />} />
            <Route path="/education-planner" element={<EducationPlanner />} />
            <Route path="/swp-planner" element={<SWPPlanner />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/:type" element={<ComingSoon />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
}

export default App;